import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useBlog } from '../context/BlogContext';
import PageTransition from '../components/PageTransition';
import RichEditor from '../components/RichEditor';

export default function CreatePost() {
  const { user } = useAuth();
  const { addPost } = useBlog();
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [excerpt, setExcerpt] = useState('');
  const [content, setContent] = useState('');
  const [tags, setTags] = useState('');
  const [readTime, setReadTime] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!title.trim() || !content.trim() || submitting) return;
    setSubmitting(true);
    setError('');
    try {
      await addPost({
        title: title.trim(),
        excerpt: excerpt.trim() || '',
        content,
        author: user.displayName,
        date: new Date().toISOString().slice(0, 10),
        image: '',
        readTime: readTime.trim() ? parseInt(readTime, 10) : 0,
        tags: tags.split(',').map((t) => t.trim()).filter(Boolean),
      }, imageFile);
      navigate('/admin');
    } catch (err) {
      console.error('Failed to publish:', err);
      setError(err.message || 'Failed to publish.');
    } finally {
      setSubmitting(false);
    }
  };

  const labelStyle = { fontSize: '0.85rem', color: 'var(--text-tertiary)', display: 'block', marginBottom: '0.4rem' };

  return (
    <PageTransition>
      <div className="container" style={{ maxWidth: '900px', paddingTop: '3rem', paddingBottom: '4rem' }}>
        <h2 style={{ fontFamily: 'var(--font-serif)', fontSize: '1.8rem', marginBottom: '2rem', fontWeight: 400 }}>New Post</h2>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          <div>
            <label style={labelStyle}>Title</label>
            <input className="form-input" value={title} onChange={(e) => setTitle(e.target.value)} required />
          </div>
          <div>
            <label style={labelStyle}>Excerpt</label>
            <input className="form-input" value={excerpt} onChange={(e) => setExcerpt(e.target.value)} placeholder="Short summary (optional)" />
          </div>
          <div>
            <label style={labelStyle}>Tags (comma-separated)</label>
            <input className="form-input" value={tags} onChange={(e) => setTags(e.target.value)} placeholder="culinary, foraging" />
          </div>
          <div>
            <label style={labelStyle}>Read time (minutes)</label>
            <input className="form-input" type="number" min="1" value={readTime} onChange={(e) => setReadTime(e.target.value)} placeholder="Auto-estimated if left empty" style={{ maxWidth: '220px' }} />
          </div>
          <div>
            <label style={labelStyle}>Image</label>
            <input type="file" accept="image/*" style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }} onChange={(e) => setImageFile(e.target.files[0] || null)} />
          </div>
          <div>
            <label style={labelStyle}>Content</label>
            <RichEditor value={content} onChange={setContent} placeholder="Write your post..." />
          </div>
          {error && <p style={{ color: 'var(--accent-warm)', fontSize: '0.85rem' }}>{error}</p>}
          <div style={{ display: 'flex', gap: '0.75rem' }}>
            <button type="submit" className="btn btn-primary" disabled={submitting}>
              {submitting ? 'Publishing...' : 'Publish Post'}
            </button>
            <button type="button" className="btn" onClick={() => navigate('/admin')}>Cancel</button>
          </div>
        </form>
      </div>
    </PageTransition>
  );
}